export default __webpack_public_path__ + "static/media/ClientMeta.12c87781.svg";